import { Component } from "@angular/core";
import { NewUiShortLinkComponent } from "./new-ui-shortLink.component";

@Component({
  selector: "app-short-link",
  template: "<p>Redirecting...</p>",
})
export class ShortLinkComponent extends NewUiShortLinkComponent {}
